import React from 'react'
import { css } from 'emotion'
import styled from 'react-emotion'
import Link from 'gatsby-link'

const ItemClass = css`
  flex: 1 80px;
  height: 100px;
  align-items: center;
  justify-content: center;
  display: flex;
  padding: 0 .5rem;
  position: relative;
  
  @media (min-width: 800px) {
    flex: 1 110px;
    padding: 0 1rem;
    margin-top: 2rem;
  }
`

const HoverVielClass = css`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  transition: .25s ease-out;  
  opacity: 0;
  height: 0;
  color: #fff;
`

const ListClass = css`
  display: flex;
  flex-wrap: wrap;
  max-width: 800px;
  margin: 0 auto;

  @media (min-width: 800px) {
    max-width: 1000px;
  }

  @media (min-width: 1025px) {
    &:hover {
      .${ItemClass} {
      }

      .${HoverVielClass} {
        height: auto;
        opacity: .8;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 3rem;
        font-style: italic;
        font-weight: bold;
        background-color: #00B386;
      }
    }
  }
`

const ItemImgClass = css`
  width: 90px;

  @media (min-width: 767px) {
		width: 100px;
  }
  
  @media (min-width: 1025px) {
    width: 90%;
    max-width: 150px;
	}
`



const PartnersList = (props) => {
  return (
    <div className={ListClass}>
      {props.partners.map(partner => (
        <div key={partner.node.id} className={ItemClass}>
          <img className={ItemImgClass} src={partner.node.frontmatter.logo} alt={partner.node.frontmatter.title} title={partner.node.frontmatter.title} />
        </div>
      ))}
      <Link to={'/testimonials'}className={HoverVielClass}>Read Their Stories</Link>
    </div>
  )
}
 
export default PartnersList;


// WEBPACK FOOTER //
// ./src/components/main/PartnersList.js